<template>
    <v-responsive>
        <template v-if="$vuetify.display.mobile">
            <!-- Order is important for the disposition -->
            <MobileNavigationDrawer
                v-model="drawer"
                :currentUser="currentUser"
                @passwordChangeClick="passwordChange = true"
            />
            <MobileAppBar
                v-model:selectedCompany="selectedCompany.name"
                :topButtonStyle="topButtonStyle"
                @back="back"
                @companySelectClick="
                    dialogCompanySelection =
                        currentUser.allAvailableCompanies.length === 1 ? null : true
                "
                @userBtnClick="drawer = !drawer"
            />
            <MobileBottomNavigation
                v-model="currentMenu"
                :currentUser="currentUser"
                :userConfig="userConfig"
                v-if="currentUser && currentUser.profile && !toBeDoneStatus"
            />
        </template>
        <template v-else>
            <v-app-bar color="background" elevation="0" class="overflow">
                <div class="d-flex w-100 h-100">
                    <div style="width: 256px" class="align-self-center">
                        <ossAccountingFirmSelector> </ossAccountingFirmSelector>
                    </div>
                    <v-row
                        no-gutters
                        class="bg-white rounded-bs-2xl w-100 px-2 flex-nowrap d-flex align-center"
                    >
                        <v-col cols="3" class="flex-grow-0 flex-shrink-0">
                            <v-text-field
                                placeholder="Entreprise sélectionnée"
                                v-model="selectedCompany.name"
                                readonly
                                data-cy="index-selectCompany"
                                variant="outlined"
                                density="comfortable"
                                :style="topButtonStyle"
                                @click="
                                    isCompanySelectionDisabled
                                        ? null
                                        : (dialogCompanySelection = true)
                                "
                                outlined
                                :append-inner-icon="isAccountingUser ? '$oss-eye' : undefined"
                                @click:append-inner.stop="
                                    $router.push({
                                        name: 'accountingClients',
                                        params: { mode: 'production' },
                                    })
                                "
                            />
                        </v-col>
                        <v-col cols="3" class="flex-grow-0 flex-shrink-0">
                            <oss-accounting-period-selector
                                :companyId="selectedCompany.id"
                                hide-details
                                placeholder="Exercice Comptable"
                                variant="outlined"
                                dense
                                :block="true"
                                :style="topButtonStyle"
                                :global="true"
                                :withAccountingClosing="true"
                                :disabled="isAccountingPeriodSelectionDisabled"
                            />
                        </v-col>
                        <v-col
                            v-if="!isAutonomousUser"
                            class="d-flex justify-center align-center flex-grow-0 flex-shrink-1"
                        >
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <div v-bind="props">
                                        <AccountableAccountVue
                                            :showLabel="true"
                                            :showValidation="false"
                                            :companyId="selectedCompany.id"
                                            inAccountableAccountType="Selected"
                                            :embeddedInput="true"
                                            :editAccountableAccount="true"
                                            :defineThirdParty="true"
                                            :displayCheckIcon="false"
                                        >
                                            <template v-slot:activator="{ props: propsAA }">
                                                <v-btn-icon
                                                    icon="$oss-accounting-plan"
                                                    v-bind="{ ...propsAA, ...props }"
                                                >
                                                </v-btn-icon>
                                            </template>
                                        </AccountableAccountVue>
                                    </div>
                                </template>
                                <span>Plan comptable</span>
                            </v-tooltip>
                        </v-col>
                        <v-col
                            v-if="!isAutonomousUser && currentUser"
                            class="d-flex justify-center align-center flex-grow-0 flex-shrink-1"
                        >
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon
                                        v-bind="props"
                                        icon="$oss-company"
                                        @click="activateEditThirdCompanies = true"
                                        :style="topButtonStyle"
                                    >
                                    </v-btn-icon>
                                </template>
                                <span>Tiers</span>
                            </v-tooltip>
                        </v-col>
                        <v-col
                            v-if="!isAutonomousUser"
                            class="d-flex justify-center align-center flex-grow-0 flex-shrink-1"
                        >
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon
                                        v-bind="props"
                                        v-if="currentUser"
                                        icon="$oss-user-card"
                                        @click="activateEditUsers = true"
                                        :style="topButtonStyle"
                                    >
                                    </v-btn-icon>
                                </template>
                                <span>Utilisateurs</span>
                            </v-tooltip>
                        </v-col>
                        <v-col class="d-flex justify-center align-center flex-grow-0 flex-shrink-1">
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon
                                        v-bind="props"
                                        v-if="currentUser"
                                        icon="$label_outline"
                                        @click="activateTagManager = true"
                                        :style="topButtonStyle"
                                    >
                                    </v-btn-icon>
                                </template>
                                <span>&#xc9;tiquettes</span>
                            </v-tooltip>
                        </v-col>
                        <v-spacer class="flex-grow-1 flex-shrink-0" />
                        <v-col class="d-flex justify-center align-center flex-grow-0 flex-shrink-1">
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <div v-bind="props">
                                        <Notification> </Notification>
                                    </div>
                                </template>
                                <span>Notifications</span>
                            </v-tooltip>
                        </v-col>
                        <v-col
                            v-if="selectedCompany.legalForm === 'SCI'"
                            class="d-flex justify-center align-center flex-grow-0 flex-shrink-1"
                        >
                            <SettingSCI :companyId="selectedCompany.id" />
                        </v-col>
                        <!-- Commented as linked component does not work for now -->
                        <!-- <v-col class="flex-shrink-1 flex-grow-0">
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <router-link
                                        v-bind="props"
                                        :to="{
                                            name: 'tasks',
                                            params: { companyId: selectedCompany.id },
                                        }"
                                        v-if="
                                            userConfig?.task.read &&
                                            currentUser.company.profile &&
                                            currentUser.company.profile.activateTask
                                        "
                                    >
                                        <v-btn-icon icon="$oss-calendar" :style="topButtonStyle" />
                                    </router-link>
                                </template>
                                <span>Gestionnaire des t&#xe2;ches</span>
                            </v-tooltip>
                        </v-col> -->
                        <v-col class="flex-shrink-1 flex-grow-0" v-if="!$vuetify.display.mobile">
                            <TutorialButtonDialog />
                        </v-col>
                        <v-col class="flex-shrink-1 flex-grow-0" v-if="isHomeAvailable">
                            <v-btn-icon
                                @click="accoutantHome()"
                                icon="$oss-outlined-home"
                                :style="topButtonStyle"
                                v-tooltip.bottom="'Accueil'"
                                data-cy="index-homepage"
                            />
                        </v-col>
                        <v-col class="flex-shrink-1 flex-grow-0">
                            <profile-menu />
                        </v-col>
                    </v-row>
                </div>
            </v-app-bar>
            <div v-if="showNavigationDrawer">
                <v-btn-icon
                    v-if="mini"
                    color="primary"
                    size="x-small"
                    elevation="0"
                    @click.stop="mini = !mini"
                    :style="styleMiniBtn"
                    class="pl-3"
                    icon="$fa-chevron-right"
                    variant="flat"
                    rounded="pill"
                >
                </v-btn-icon>
                <v-btn-icon
                    v-else
                    color="secondary"
                    size="x-small"
                    elevation="0"
                    @click.stop="mini = !mini"
                    :style="styleMiniBtn"
                    class="px-0"
                    icon="$fa-chevron-left"
                    variant="flat"
                    rounded="pill"
                >
                </v-btn-icon>
            </div>
            <v-navigation-drawer
                app
                clipped
                flat
                color="primary"
                class="rounded-te-xl border-0"
                :rail="mini"
                style="z-index: 99"
            >
                <v-list
                    lines="one"
                    :nav="true"
                    true
                    base-color="white"
                    density="compact"
                    class="space-y-1 text-lg"
                >
                    <!--  -->
                    <v-list-item :to="{ name: 'dashboard' }" v-if="userConfig?.business?.dashboard">
                        <template #prepend>
                            <v-icon>$oss-dashboard</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                            {{ $t("menu.dashboard") }}
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :to="{ name: 'dashboardAccounting' }"
                        v-if="showAccountingDashboardForClient && isAllowedToDashboardAccounting"
                    >
                        <template #prepend>
                            <v-icon>$fa-table</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                            {{ $t("menu.dashboardAccounting") }}
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :to="{ name: 'budgets' }"
                        v-if="userConfig?.budget?.read && isAllowedToBudget"
                    >
                        <template #prepend>
                            <v-icon>$oss-bar-chart</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                            $t("menu.budgets")
                        }}</v-list-item-title>
                    </v-list-item>

                    <v-list-group value="outstanding" v-if="showOutStandingCount > 1">
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                class="v-list-item-title-active"
                                v-if="!mini"
                                v-bind="props"
                                prepend-icon="$fa-file-invoice"
                                :active="
                                    currentRouteName === 'outstandingTPC' ||
                                    currentRouteName === 'outstandingUser'
                                "
                            >
                                <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                    Encours
                                </v-list-item-title>
                            </v-list-item>
                        </template>

                        <v-list-item
                            :to="{ name: 'outstandingTPC', params: { mode: 'client' } }"
                            v-if="currentUser.showOutStandingClient && !isAutonomousUser"
                            prepend-icon="$fa-file-invoice"
                        >
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                {{ $t("menu.outstandingClient") }}
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            :to="{ name: 'outstandingTPC', params: { mode: 'supplier' } }"
                            v-if="currentUser.showOutStandingSupplier && !isAutonomousUser"
                            prepend-icon="$fa-file-invoice"
                        >
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                {{ $t("menu.outstandingSupplier") }}
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="currentUser.showOutStandingUser && !isAutonomousUser"
                            prepend-icon="$fa-file-invoice"
                            :to="{ name: 'outstandingUser', params: { mode: 'outstandingUser' } }"
                        >
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                {{ $t("menu.outstandingUser") }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <v-list-item
                        v-else-if="currentUser.showOutStandingClient && !isAutonomousUser"
                        :to="{ name: 'outstandingTPC', params: { mode: 'client' } }"
                    >
                        <template #prepend>
                            <v-icon>$fa-file-invoice</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                            $t("menu.outstandingClient")
                        }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-else-if="currentUser.showOutStandingSupplier && !isAutonomousUser"
                        :to="{ name: 'outstandingTPC', params: { mode: 'supplier' } }"
                    >
                        <template #prepend>
                            <v-icon>$fa-file-invoice</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                            $t("menu.outstandingSupplier")
                        }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-else-if="
                            (currentUser.showOutStandingExpenseReport ||
                                currentUser.showOutStandingSalary) &&
                            !isAutonomousUser
                        "
                        :to="{ name: 'outstandingUser', params: { mode: 'outstandingUser' } }"
                    >
                        <template #prepend>
                            <v-icon>$fa-file-invoice</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                            $t("menu.outstandingUser")
                        }}</v-list-item-title>
                    </v-list-item>

                    <v-divider v-if="enableBank" />

                    <v-list-group v-if="enableBank" v-model="isBankExpanded">
                        <template v-slot:activator="{ isOpen, props }">
                            <v-list-item
                                prepend-icon="$oss-bank"
                                @click="navigateToBank()"
                                class="pr-0"
                                :active="currentRouteName === 'bank'"
                            >
                                <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                    {{ $t("menu.bank") }}
                                </v-list-item-title>
                                <template v-slot:append>
                                    <v-btn-icon
                                        v-if="
                                            bankTransactionUsedTags &&
                                            bankTransactionUsedTags.length
                                        "
                                        @click.stop="toggleExpandBank()"
                                        class="custom-expand-button"
                                        v-bind="props"
                                        color="primary_foreground"
                                        :icon="isOpen ? '$fa-chevron-up' : '$fa-chevron-down'"
                                    >
                                    </v-btn-icon>
                                </template>
                            </v-list-item>
                        </template>
                        <div class="expanded-group-content">
                            <template v-for="(tag, index) in bankTransactionUsedTags" :key="index">
                                <v-list-subheader v-if="tag.header">
                                    {{ tag.header }}
                                </v-list-subheader>
                                <v-list-item
                                    :inset="tag.header"
                                    density="compact"
                                    v-else
                                    :to="{ name: 'bank-tag', params: { tagId: tag.id } }"
                                >
                                    <v-list-item-title
                                        class="v-list-item-title-active"
                                        v-if="!mini"
                                    >
                                        {{ tag.text ? `${tag.text} (${tag.count})` : tag.header }}
                                    </v-list-item-title>
                                </v-list-item>
                            </template>
                        </div>
                    </v-list-group>

                    <v-list-group v-if="userConfig?.document?.read" v-model="isDocumentExpanded">
                        <template v-slot:activator="{ isOpen, props }">
                            <v-list-item
                                prepend-icon="$oss-archives"
                                @click="navigateToDocuments()"
                                class="pr-0"
                                :active="currentRouteName === 'documents'"
                            >
                                <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                                    $t("menu.documents")
                                }}</v-list-item-title>
                                <template v-slot:append>
                                    <v-btn-icon
                                        @click.stop="toggleExpandDocument()"
                                        class="custom-expand-button"
                                        v-bind="props"
                                        color="primary_foreground"
                                        :icon="isOpen ? '$fa-chevron-up' : '$fa-chevron-down'"
                                    >
                                    </v-btn-icon>
                                </template>
                            </v-list-item>
                        </template>
                        <div class="expanded-group-content">
                            <template v-if="enableBank">
                                <v-list-subheader>Filtres</v-list-subheader>
                                <template v-for="filter in usedFilters" :key="filter.value">
                                    <v-list-item
                                        class="ml-3"
                                        density="compact"
                                        @click="
                                            navigateToDocumentsWithQuery(filter.type, filter.value)
                                        "
                                    >
                                        <v-list-item-title
                                            class="v-list-item-title-active"
                                            v-if="!mini"
                                            >{{ filter.name }}</v-list-item-title
                                        >
                                    </v-list-item>
                                </template>
                            </template>
                            <TreeView
                                v-if="documentUsedTags"
                                :items="documentUsedTags"
                                :branchClick="true"
                            >
                                <template v-slot:branch="{ name }">
                                    <v-list-subheader>{{ name }}</v-list-subheader>
                                </template>
                                <template v-slot:leaf="{ name, id }">
                                    <v-list-item
                                        :key="id"
                                        density="compact"
                                        :to="{ name: 'documents-tag', params: { tagId: id } }"
                                    >
                                        <v-list-item-title
                                            class="v-list-item-title-active"
                                            v-if="!mini"
                                            >{{ name }}</v-list-item-title
                                        >
                                    </v-list-item>
                                </template>
                            </TreeView>
                        </div>
                    </v-list-group>

                    <v-list-item
                        v-if="
                            userConfig?.salesInvoice.read &&
                            selectedCompany.profile &&
                            selectedCompany.profile.createSalesInvoice &&
                            isAllowedToInvoice
                        "
                        :to="{ name: 'invoices' }"
                    >
                        <template #prepend>
                            <v-icon>$oss-invoice</v-icon>
                        </template>
                        <v-list-item-title
                            class="v-list-item-title-active"
                            v-if="!mini"
                            data-cy="index-invoices"
                            >{{ $tm("menu.invoices") }}</v-list-item-title
                        >
                    </v-list-item>

                    <v-list-item
                        v-if="isAllowedToStock && selectedCompany?.profile?.stock"
                        :to="{ name: 'stocks' }"
                    >
                        <template #prepend>
                            <v-icon>$oss-archives</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                            $tm("menu.stocks")
                        }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-if="
                            (!selectedCompany.profile
                                ? true
                                : selectedCompany.profile.createExpenseReport) &&
                            !isAutonomousUser &&
                            isAllowedToExpenseReport
                        "
                        :to="{ name: 'expenseReports' }"
                    >
                        <template #prepend>
                            <v-icon>$oss-expense-report</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                            $t("menu.expenseReports")
                        }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-if="userConfig?.declaration.read && isAllowedToTaxDeclaration"
                        :to="{ name: 'taxForms' }"
                    >
                        <template #prepend>
                            <v-icon>$fa-file-contract</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                            Déclarations fiscales
                        </v-list-item-title>
                    </v-list-item>

                    <v-divider v-if="userConfig?.accounting.read" :class="mini ? 'hide' : 'show'" />

                    <v-list-group
                        prepend-icon="$oss-analysis"
                        v-if="
                            userConfig?.accounting.read && isAllowedToAccounting && isUserHasAccess
                        "
                    >
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                class="v-list-item-title-active"
                                v-if="!mini"
                                v-bind="props"
                                prepend-icon="$oss-analysis"
                            >
                                <v-list-item-title class="v-list-item-title-active-no-word">
                                    Comptabilité
                                </v-list-item-title>
                            </v-list-item>
                        </template>

                        <v-list-item
                            v-if="userConfig?.accounting.write && !isAutonomousUser"
                            :to="{ name: 'accountingPeriodOpening' }"
                        >
                            <template #prepend>
                                <v-icon>$oss-edit</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                                $t("menu.accountingPeriodOpening")
                            }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            :model-value="'accountingLog'"
                            v-if="userConfig?.accounting.log && !isAutonomousUser"
                            :to="{ name: 'accountingLog' }"
                        >
                            <template #prepend>
                                <v-icon>$oss-state</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                                $t("menu.accountingLog")
                            }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="userConfig?.accounting.accountingLine && !isAutonomousUser"
                            :to="{ name: 'accountingLines' }"
                        >
                            <template #prepend>
                                <v-icon>$oss-state</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                                $t("menu.accountingLines")
                            }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="userConfig?.accounting.generalLedger"
                            :to="{ name: 'generalLedger' }"
                        >
                            <template #prepend>
                                <v-icon>$oss-general-ledger</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                {{
                                    isAutonomousUser
                                        ? "Comptes en détail"
                                        : $tm("menu.generalLedger")
                                }}
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="userConfig?.capitalAsset?.read && isAllowedToFixedAsset"
                            :to="{
                                name: 'fixedAssets',
                                params: {
                                    acKey: 'rIr4hG5NdQWyEnIXvhnYtmmm',
                                    companyId: companyId,
                                    accountingPeriodId: lastSelectedAccountingPeriodId || 'xx',
                                },
                            }"
                        >
                            <template #prepend>
                                <v-icon>$oss-analysis</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                Immobilisations
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="userConfig?.accounting.auditReport && isAllowedToAuditReport"
                            :to="{ name: 'auditReport' }"
                        >
                            <template #prepend>
                                <v-icon>$oss-folder</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                                isAutonomousUser ? "Fin d'exercice" : $t("menu.auditReport")
                            }}</v-list-item-title>
                        </v-list-item>
                        <!-- Soldes intermédiaires de gestion || CR || Bilan -->
                        <v-list-item
                            v-if="
                                userConfig?.accounting.dashboard && isAllowedToDashboardAccounting
                            "
                            :to="{
                                name: 'dashboardAccounting',
                            }"
                        >
                            <template #prepend>
                                <v-icon>$fa-table</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                                $t("menu.dashboardAccounting")
                            }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="userConfig?.accounting.import"
                            :to="{ name: 'accountingItems' }"
                        >
                            <template #prepend>
                                <v-icon>$oss-import</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                Imports
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="userConfig?.accounting.export"
                            :to="{ name: 'exportAccounting' }"
                        >
                            <template #prepend>
                                <v-icon>$oss-export</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                {{ $t("menu.export") }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <v-list-item
                        v-if="userConfig?.accounting.export && !isAllowedToAccounting"
                        :to="{ name: 'exportAccounting' }"
                    >
                        <template #prepend>
                            <v-icon>$oss-export</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                            $t("menu.export")
                        }}</v-list-item-title>
                    </v-list-item>

                    <v-list-group
                        v-if="
                            userConfig?.accounting.read &&
                            (userConfig?.accounting.audit ||
                                userConfig?.accounting.openPoints ||
                                userConfig?.accountingRule.read) &&
                            !isAutonomousUser &&
                            isAllowedToAccounting &&
                            isUserHasAccess
                        "
                        :model-value="false"
                    >
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                class="v-list-item-title-active"
                                v-if="!mini"
                                v-bind="props"
                                prepend-icon="$oss-analysis"
                            >
                                <v-list-item-title
                                    class="v-list-item-title-active"
                                    v-if="!mini"
                                    style="white-space: normal; word-break: break-word"
                                >
                                    Gestion comptable
                                </v-list-item-title>
                            </v-list-item>
                        </template>

                        <v-list-item
                            :to="{ name: 'companyStatusBoard' }"
                            v-if="userConfig?.accounting.read"
                        >
                            <template #prepend>
                                <v-icon>$oss-analysis</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                Etat du dossier
                            </v-list-item-title>
                        </v-list-item>

                        <!-- <v-list-item
                            :model-value="'auditStatus'"
                            :to="{ name: 'auditStatus' }"
                            v-if="userConfig?.accounting.audit"
                        >

                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{ $t("menu.auditStatus") }}</v-list-item-title>
                        </v-list-item> -->

                        <v-list-item
                            :to="{ name: 'openPoints' }"
                            v-if="userConfig?.accounting.openPoints && isAllowedToOpenPoint"
                        >
                            <template #prepend>
                                <v-icon>$oss-analysis</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                                $t("menu.openPoints")
                            }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            :to="{ name: 'wording-analysis-client-side' }"
                            v-if="userConfig?.accountingRule.read"
                        >
                            <template #prepend>
                                <v-icon>$oss-analysis</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                Analyse de libellé
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            :to="{ name: 'document-rules-client-side' }"
                            v-if="userConfig?.accountingRule?.read"
                        >
                            <template #prepend>
                                <v-icon>$oss-analysis</v-icon>
                            </template>
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                                {{ $t("menu.documentRules") }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <v-list-item
                        :to="{ name: 'companyEdition', params: { companyId: selectedCompany.id } }"
                        v-if="userConfig?.company.read"
                    >
                        <template #prepend>
                            <v-icon>$oss-folder</v-icon>
                        </template>
                        <v-list-item-title
                            class="v-list-item-title-active"
                            v-if="!mini"
                            data-cy="index-dossier"
                        >
                            {{ isAccountingUser ? $t("menu.settingsAdmin") : $t("menu.settings") }}
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="isUserInAccountingFirm" :to="{ name: 'chat' }">
                        <template #prepend>
                            <v-icon>$oss-chat-filled</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                            <v-badge
                                color="error"
                                :content="chatUser.unreadMessageCount || 0"
                                dot
                                floating
                                v-if="chatUser && chatUser.unreadMessageCount"
                            >
                                <span>{{ $t("menu.chat") }}</span>
                            </v-badge>
                            <span v-else>{{ $t("menu.chat") }}</span>
                        </v-list-item-title>
                    </v-list-item>
                    <!-- </v-list>

                        <v-list-item
                            :to="{ name: 'wording-analysis-client-side' }"
                            v-if="userConfig?.accountingRule.read"
                        >
                            <v-list-item-title class="v-list-item-title-active" v-if="!mini">Analyse de libellé</v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <v-list-item
                        :to="{ name: 'companyEdition', params: { companyId: selectedCompany.id } }"
                        v-if="userConfig?.company.read"
                    >
                        <template #prepend>
                            <v-icon>$oss-folder</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">{{
                            isAccountingUser ? $t("menu.settingsAdmin") : $t("menu.settings")
                        }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="isUserInAccountingFirm" :to="{ name: 'chat' }">
                        <template #prepend>
                            <v-icon>$oss-chat-filled</v-icon>
                        </template>
                        <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                            <v-badge
                                color="error"
                                :content="chatUser?.unreadMessageCount || 0"
                                dot
                                floating
                                v-model="chatUser.unreadMessageCount"
                            >
                                <span>{{ $t("menu.chat") }}</span>
                            </v-badge>
                        </v-list-item-title>
                    </v-list-item> -->
                </v-list>

                <template #append>
                    <v-row no-gutters v-if="!mini" class="mb-4">
                        <v-col cols="3" class="d-flex justify-end align-end text--primary px-1">
                            by
                        </v-col>
                        <v-col cols="9" class="d-flex">
                            <v-img src="../assets/img/bobbee_hrz.png" height="30px" />
                        </v-col>
                    </v-row>
                    <div v-else class="mb-4 d-flex justify-center">
                        <v-img src="../assets/img/bobbee_mini.png" height="30px" />
                    </div>
                </template>
            </v-navigation-drawer>
        </template>
        <v-main>
            <router-view v-if="!isOver30Days" />
        </v-main>
        <ThirdPartyCompanies v-model="activateEditThirdCompanies" v-if="activateEditThirdCompanies">
        </ThirdPartyCompanies>
        <UsersDialog v-model="activateEditUsers" v-if="activateEditUsers"> </UsersDialog>
        <oss-dialog
            title="Gérer vos étiquettes et journaux"
            v-model="activateTagManager"
            v-if="activateTagManager"
            width="90vw"
        >
            <tag-manager> </tag-manager>
        </oss-dialog>
        <oss-dialog
            v-model="isFirstConnection"
            v-if="!hasAlreadyReceiveNotificationToday && isOver15Days && isFirstConnection"
            width="30vw"
            @close="setNotificationDateForToday()"
        >
            <v-card>
                <v-card-title>
                    {{ $t("notification.offer.over15DaysTitle") }}
                </v-card-title>
                <v-card-text>
                    <span>{{
                        $t("notification.offer.over15Days", { diff: diffDate }, diffDate)
                    }}</span
                    ><br />
                    <span>{{ $t("notification.offer.contact") }}</span>
                </v-card-text>
            </v-card>
        </oss-dialog>
        <v-overlay
            persistent
            v-model="isOver30Days"
            height="100vh"
            width="100vw"
            v-else-if="!hasAlreadyReceiveNotificationToday && isOver30Days"
        >
            <v-card width="25vw" location="center center">
                <v-card-title>
                    {{ $t("notification.offer.over30DaysTitle") }}
                </v-card-title>
                <v-card-text>
                    <span>{{ $t("notification.offer.over30Days") }}</span
                    ><br />
                    <span>{{ $t("notification.offer.contact") }}</span>
                </v-card-text>
            </v-card>
        </v-overlay>
        <ChatList
            v-show="openChatList"
            :position="!$vuetify.display.mobile ? '' : '10px'"
            @chatSelected="onChatSelected"
            v-if="isUserConnected"
        />

        <oss-dialog
            v-model="dialogCompanySelection"
            :max-width="!$vuetify.display.mobile ? '1000px' : undefined"
            :min-height="!$vuetify.display.mobile ? '600px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            title="Sélectionnez une société"
        >
            <v-row no-gutters class="w-100">
                <v-col cols="12" class="pb-3">
                    <v-text-field-filled
                        v-model="companySearch"
                        label="Entrez le nom d'une société"
                        data-cy="index-companySearch"
                        class="mb-2 w-100"
                        autofocus
                        density="compact"
                    />
                </v-col>
                <v-col cols="12">
                    <v-virtual-scroll
                        :items="companyList"
                        height="600"
                        width="1000"
                        item-height="48"
                    >
                        <template #default="{ item: company }">
                            <v-list-item
                                @click="
                                    selectedCompany = company;
                                    dialogCompanySelection = false;
                                    companySearch = '';
                                "
                                :model-value="company.id"
                                border
                                rounded="xl"
                                class="mb-2"
                                lines="two"
                            >
                                <v-list-item-title
                                    data-cy="index-companyName"
                                    class="v-list-item-title-active text-wrap"
                                >
                                    {{ company.shortname || company.name }}
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    >Siret: {{ company.siret }}</v-list-item-subtitle
                                >
                                <template #append>
                                    <v-icon color="grey lighten-1">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                        </template>
                    </v-virtual-scroll>
                </v-col>
            </v-row>
        </oss-dialog>

        <v-snackbar
            v-model="apolloErrorSnackBar"
            :color="apolloErrors.type"
            multi-line
            timeout="5000"
        >
            {{ apolloErrors.errorType }} : {{ apolloErrors.request }}
            <template v-for="(msg, index) of apolloErrors.messages" :key="index">
                <div>{{ msg }}</div>
            </template>

            <template #actions>
                <v-btn color="white" variant="plain" @click="apolloErrorSnackBar = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <SnackbarSurvey></SnackbarSurvey>
    </v-responsive>
</template>
<script lang="ts">
import { Apollo, State2Way } from "@/decorators";
import gql from "graphql-tag";
import { sortBy } from "lodash";
import moment from "moment-timezone";
import { User } from "../store/store";
import AccountableAccountVue from "./AccountableAccount.vue";
import CompaniesTable from "./admin/CompaniesTable.vue";
import ProfileMenu from "./auth/ProfileMenu.vue";
import ChatList from "./chat/ChatList.vue";
import MergeCompanies from "./MergeCompanies.vue";
import Notification from "./Notification.vue";
import ossAccountingPeriodSelector from "./ossComponents/ossAccountingPeriodSelector.vue";
import TagManager from "./tag/TagManager.vue";
import UserTaskList from "./tasks/UserTaskList.vue";
import ThirdPartyCompanies from "./ThirdPartyCompanies.vue";
import Tutorial from "./Tutorial.vue";
import TutorialButtonDialog from "./tutorial/TutorialButtonDialog.vue";
import UsersDialog from "./user/UsersDialog.vue";
import UserWorkingTime from "./user/UserWorkingTime.vue";
// import ImportMapping from "./ImportMapping.vue";
import TreeView from "@/components/views/TreeView.vue";
import SettingSCI from "./configuration/settings/SettingSCI.vue";
import { ossAccountingFirmSelector } from "./ossComponents/ossAccountingFirmSelector.vue";

// import BobbeeChristmas from "./BobbeeChristmas.vue"
import TutorialsComp, { TutorialsList } from "./tutorial/TutorialsList.vue";

import { showChatList } from "../services/chatServices";
import { formatTagsToTreeView, getCompanyTags } from "../services/tagServices";
import { updateMaintenance } from "../services/updateMaintenance";

import getEnv from "@/env";
import ACCOUNTING_FIRM_CLIENT from "../graphql/billing/AccountingFirmClient.gql";
import ACCOUNTING_COMPANY_OF_COMPANY from "../graphql/company/AccountingCompanyOfCompany.gql";
import USED_TAG_QUERY from "../graphql/tag/UsedTags.gql";
import GET_ALL_TUTORIALS from "../graphql/tutorials/GetAllTutorials.gql";
import { logOutUser, setCurrentCompany } from "../services/userServices";
import { NotificationBase } from "./NotificationBase";

import { checkAccessRights, OfferAccessRight } from "../services/accessRightServices";
import { getDBFormattedDate } from "../services/dateServices";

import { Offer_type } from "@/types/offer.types";
import { Component, Ref, toNative, Watch } from "vue-facing-decorator";

import SnackbarSurvey from "@/components/snackbar/SnackbarSurvey.vue";
import logoBobbeeMini from "../assets/img/bobbee_mini.png";
import MobileAppBar from "./navigation/MobileAppBar.vue";
import MobileBottomNavigation from "./navigation/MobileBottomNavigation.vue";
import MobileNavigationDrawer from "./navigation/MobileNavigationDrawer.vue";

const env = getEnv();

@Component({
    components: {
        WorkingTime: UserWorkingTime,
        ChatList,
        OssAccountingPeriodSelector: ossAccountingPeriodSelector,
        ProfileMenu,
        Tutorial,
        AccountableAccountVue,
        CompaniesTable,
        Tutorials: TutorialsComp,
        TaskList: UserTaskList,
        MergeCompanies,
        ThirdPartyCompanies,
        UsersDialog,
        Notification,
        TagManager,
        ossAccountingFirmSelector,
        // ImportMapping,
        TreeView,
        SettingSCI,
        TutorialButtonDialog,
        // BobbeeChristmas,
        MobileAppBar,
        MobileBottomNavigation,
        MobileNavigationDrawer,
        SnackbarSurvey,
    },
})
export class Index extends NotificationBase {
    mini = false;
    drawer = false;

    christmasAnimation = true;

    firstLoginDialog = false;

    apolloErrorSnackBar = false;

    offsetTop = 0;

    @State2Way("updateCurrentRoute", "currentRoute")
    currentRouteStore!: string;

    @State2Way("updateActivateHelp", "activateHelp")
    activateHelp!: boolean;

    @Ref("tutorialWizard") tutorialWizard!: TutorialsList;

    isFirstConnection = true;

    get offerType() {
        return this.$store.state.offerType;
    }

    get diffDate() {
        if (!this.$store.state?.selected_company?.createdAt) {
            return null;
        }
        const limitDate = new Date(this.$store.state.selected_company.createdAt);
        limitDate.setDate(limitDate.getDate() + 30);
        limitDate.setHours(23);
        limitDate.setMinutes(59);
        const actualDate = new Date();
        const actualTime = actualDate.getTime();
        const limitTime = limitDate.getTime();
        const diffTime = (limitTime - actualTime) / 86400000;
        return Math.trunc(diffTime);
    }

    get isOver15Days() {
        if (!this.$store.state?.selected_company?.createdAt) {
            return false;
        }
        const limitDate = new Date(this.$store.state.selected_company.createdAt);
        limitDate.setDate(limitDate.getDate() + 15);
        limitDate.setHours(23);
        limitDate.setMinutes(59);
        const actualDate = new Date();
        if (
            this.offerType == Offer_type.BUSINESS_BASIC &&
            limitDate.getTime() < actualDate.getTime()
        ) {
            return true;
        } else {
            return false;
        }
    }

    get isOver30Days() {
        if (!this.$store.state?.selected_company?.createdAt) {
            return false;
        }
        const limitDate = new Date(this.$store.state.selected_company.createdAt);
        limitDate.setDate(limitDate.getDate() + 30);
        limitDate.setHours(23);
        limitDate.setMinutes(59);
        const actualDate = new Date();
        if (
            this.offerType == Offer_type.BUSINESS_BASIC &&
            limitDate.getTime() < actualDate.getTime()
        ) {
            return true;
        } else {
            return false;
        }
    }

    get hasAlreadyReceiveNotificationToday() {
        const dateString: string | null = localStorage.getItem(
            "lastTimeFreemiumNotificationWasDisplayed",
        );

        if (dateString === null) {
            return false;
        } else {
            const date: Date = new Date(dateString);
            const dateNow: Date = new Date();
            if (date.getDate() != dateNow.getDate()) {
                return false;
            }
            return true;
        }
    }

    get isUserHasAccess() {
        return this.$store.getters.isUserHasAccess();
    }

    get isAllowedToBudget() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.BUSINESS_BASIC:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // return true;
        // default:
        // return false;
        // }
        return checkAccessRights(this.currentUser, "budget", "read", true, "isAllowedToBudget");
    }

    get isAllowedToAuditReport() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_BASIC:
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.ACCOUNTING_STARTER:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // if (this.isUserHasAccess) {
        // return true;
        // }
        // return false;
        // default:
        // return false;
        // }
        return checkAccessRights(
            this.currentUser,
            "auditReport",
            "read",
            true,
            "isAllowedToAuditReport",
            true,
        );
    }

    get isAllowedToFixedAsset() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_BASIC:
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.ACCOUNTING_STARTER:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.BUSINESS_BASIC:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.TRAINING:
        // if (this.isUserHasAccess) {
        // return true;
        // }
        // return false;
        // default:
        // return false;
        // }
        return OfferAccessRight.checkOfferAccessRight("isAllowedToFixedAsset", true);
    }

    get isAllowedToDashboardAccounting() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_BASIC:
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.ACCOUNTING_STARTER:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.BUSINESS_BASIC:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.TRAINING:
        // if (this.isUserHasAccess) {
        // return true;
        // }
        // return false;
        // default:
        // return false;
        // }
        return checkAccessRights(
            this.currentUser,
            "accounting",
            "dashboard",
            true,
            "isAllowedToDashboardAccounting",
            true,
        );
    }

    get isAllowedToOpenPoint() {
        // switch (this.offerType) {
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.ACCOUNTING_BASIC:
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.ACCOUNTING_STARTER:
        // case Offer_type.TRAINING:
        // if (this.isUserHasAccess) {
        // return true;
        // }
        // return false;
        // default:
        // return false;
        // }
        return checkAccessRights(
            this.currentUser,
            "accounting",
            "openPoints",
            true,
            "isAllowedToOpenPoint",
            true,
        );
    }

    get isAllowedToRestitution() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_BASIC:
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.BUSINESS_BASIC:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // if (this.isUserHasAccess) {
        // return true;
        // }
        // return false;
        // default:
        // return false;
        // }
        return OfferAccessRight.checkOfferAccessRight("isAllowedToRestitution", true);
    }

    get isAllowedToForecastManagement() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // return true;
        // default:
        // return false;
        // }
        return OfferAccessRight.checkOfferAccessRight("isAllowedToForecastManagement", false);
    }

    get isAllowedToInvoice() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.BUSINESS_BASIC:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // return true;
        // default:
        // return false;
        // }
        return checkAccessRights(
            this.currentUser,
            "salesInvoice",
            "read",
            true,
            "isAllowedToInvoice",
        );
    }

    get isAllowedToStock() {
        return checkAccessRights(this.currentUser, "stock", "read", true, "isAllowedToStock");
    }

    get isAllowedToExpenseReport() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_STARTER:
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // return true;
        // default:
        // return false;
        // }
        return checkAccessRights(
            this.currentUser,
            "expenseReport",
            "read",
            true,
            "isAllowedToExpenseReport",
        );
    }

    get currentRouteName() {
        return this.$router.currentRoute.value.name;
    }

    get isAllowedToTaxDeclaration() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_BASIC:
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // if (this.isUserHasAccess) {
        // return true;
        // }
        // return false;
        // default:
        // return false;
        // }
        return checkAccessRights(
            this.currentUser,
            "declaration",
            "read",
            true,
            "isAllowedToTaxDeclaration",
            true,
        );
    }

    get isAllowedToAccounting() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_BASIC:
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.BUSINESS_BASIC:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // if (this.isUserHasAccess) {
        // return true;
        // }
        // return false;
        // default:
        // return false;
        // }
        return checkAccessRights(
            this.currentUser,
            "accounting",
            "read",
            true,
            "isAllowedToAccounting",
            true,
        );
    }

    activateUserWorkingTime = false;

    activateEditThirdCompanies = false;

    activateUserTaskList = false;

    activateEditUsers = false;

    wizardStep = 0;

    activateTagManager: boolean = false;

    settingSciDialog: boolean = false;

    // activateBuildingsDialog:boolean = false

    // wizardStep = 0;

    // activateMergingCompany = true

    // activateToMergeCompanies = true

    // mergeLoading = false

    // thirdPartyCompany:any = ""

    // thirdPartyCompanyDatasID = ""

    // tpCompaniesIdToMerge= []

    date = moment().format("DD-MM-YYYY");

    showUserProfil: boolean = false;

    passwordChange: boolean = false;

    extendDocument: boolean = false;
    extendBankTransaction: boolean = false;

    dialogCompanySelection: boolean = false;

    password: string = "";

    pwdConfirmation: string = "";

    loading: boolean = false;

    showPassword: boolean = false;

    // newIban = {
    //     iban: "",
    //     default: true
    // }

    // iban = []

    // actions = {
    //     action: new DialogAction()
    // }

    valid = false;

    isPasswordModified = false;

    alreadyAskedEmailVerification = false;
    emailConfirmationResent = false;

    companySearch = "";

    isDocumentExpanded = false;

    isBankExpanded = false;

    navigateToBank(): void {
        this.$router.push({ name: "bank" });
    }

    navigateToDocuments(): void {
        this.$router.push({ name: "documents" });
    }

    navigateToDocumentsWithQuery(type: string, value: string): void {
        this.$router.push({
            name: "documents",
            query: { [type]: value },
        });
    }

    toggleExpandDocument(): void {
        this.isDocumentExpanded = !this.isDocumentExpanded;
    }

    toggleExpandBank(): void {
        this.isBankExpanded = !this.isBankExpanded;
    }

    get isCompanySelectionDisabled() {
        if (
            this.currentUser.allAvailableCompanies.length === 1 ||
            (this.$route.params?.companyId && this.$route.params.companyId === this.companyId)
        ) {
            return true;
        }
        if (
            this.currentRoute === "declaration" ||
            this.currentRoute === "taxForm2-new" ||
            this.currentRoute === "taxForm2" ||
            this.currentRoute === "declaration-new"
        ) {
            return true;
        }
        return false;
    }

    get isAccountingPeriodSelectionDisabled() {
        if (
            this.currentRoute === "declaration" ||
            this.currentRoute === "taxForm2-new" ||
            this.currentRoute === "taxForm2" ||
            this.currentRoute === "declaration-new"
        ) {
            return true;
        }
        return false;
    }

    get currentRoute() {
        return this.$route.name;
    }

    @Watch("currentRoute")
    onCurrentRouteChange() {
        this.currentRouteStore = this.currentRoute as string;
    }

    routerPush(options) {
        this.$router.push(options).catch(() => {});
    }

    accoutantHome() {
        this.$router.push({ name: "accountant-home" });
    }

    get env() {
        return env;
    }

    get accountingClientsPage() {
        return this.$route.name === "accountingClients";
    }

    set currentMenu(data) {
        this.currentMenu = data;
    }

    get currentMenu() {
        switch (this.$route.name) {
            // Dashboard
            case "dashboard":
                return "dashboard";

            // Budget
            case "budgets":
                return "budgets";

            // Dashboard Accounting
            case "dashboardAccounting":
                return "dashboardAccounting";

            //Open Points
            case "openPoints":
                return "openPoints";

            // Outstanding
            case "outstanding":
                return "outstanding";

            // Bank
            case "bank":
                return "bank";
            case "reconciliation/bankTransaction":
                return "bank";

            // Document
            case "documents":
                return "documents";
            case "document": {
                return "documents";
            }
            case "reconciliation/document":
                return "documents";

            // Audit Status
            case "auditStatus":
                return "auditStatus";
            case "checkRecurrentInvoice":
                return "auditStatus";
            case "checkExpenseReport":
                return "auditStatus";
            case "checkVATGift":
                return "auditStatus";
            case "CheckBilanZTill":
                return "auditStatus";
            case "checkInvoiceNumbers":
                return "auditStatus";
            case "purchases-over-500":
                return "auditStatus";
            case "used-accountable-accounts-table":
                return "auditStatus";
            case "doubtfull-accounts":
                return "auditStatus";
            case "checkBankAccountBalance":
                return "auditStatus";

            // Invoice
            case "invoices":
                return "invoices";
            case "invoiceNew":
                return "invoices";
            case "invoiceEdition":
                return "invoices";
            case "quotationNew":
                return "invoices";
            case "quotationEdition":
                return "invoices";
            case "billDeliveryNew":
                return "invoices";
            case "billDeliveryEdition":
                return "invoices";

            // ZTill
            case "ztillReceipts":
                return "ztillReceipts";
            case "zTillReceipt":
                return "ztillReceipts";

            // Expense Report
            case "expenseReports":
                return "expenseReports";
            case "expenseReport":
                return "expenseReports";
            case "expenseReportNew":
                return "expenseReports";

            // TaxForm
            case "taxForms":
                return "taxForms";
            case "taxForm":
                return "taxForms";

            // Tasks
            case "tasks":
                return "tasks";
            case "task":
                return "tasks";

            // Accounting Items
            case "accountingItems":
                return "accountingItems";
            case "importFec":
                return "accountingItems";

            // Accounting Period
            case "accountingPeriod":
                return "accountingPeriod";

            // General Ledger
            case "generalLedger":
                return "generalLedger";

            case "fixedAssets":
                return "fixedAssets";

            case "auditReport":
                return "auditReport";

            // Export Accounting
            case "exportAccounting":
                return "exportAccounting";

            // VAT Declaration
            // case "vatDeclarations":
            //     return "vatDeclarations";
            // case "vatDeclaration":
            //     return "vatDeclarations";
            // case "vatDeclarationNew":
            //     return "vatDeclarations";

            // Company Edition
            case "companyEdition": {
                return "companyEdition";
            }
            case "companyEditionTab": {
                return "companyEdition";
            }
            case "users-details":
                return "companyEdition";

            // Admin
            case "adminHome":
                return "adminHome";

            // ImportMapping
            case "importMapping":
                return "importMapping";
            default:
                return null;
        }
    }

    get showAccountingDashboardForClient() {
        // if (this.isAccountingUser) {
        //     return false
        // }
        if (this.accountingFirm?.id && this.currentUser.company.id === this.accountingFirm.id) {
            return false;
        }
        if (!this.userConfig?.accounting?.dashboard) {
            return false;
        }
        if (!this.accountingFirmClient?.accountingAvailabilityDate) {
            return false;
        }
        return true;
    }

    get emailVerification() {
        if (!env.ENABLE_COGNITO) return false;
        if (!this.currentUser || !this.currentUser.id) return false;
        if (!this.currentUser.emailVerified && !this.alreadyAskedEmailVerification) {
            return true;
        }
        return false;
    }

    set emailVerification(value) {
        if (!value) this.alreadyAskedEmailVerification = true;
    }

    backBtnList = {
        "reconciliation/bankTransaction": 1,
        "reconciliation/document": 1,
        toBeDone: 1,
        document: 1,
        expenseReportNew: 1,
        expenseReport: 1,
        zTillReceipt: 1,
    };

    @State2Way("updateToBeDoneStatus", "toBeDoneStatus")
    toBeDoneStatus!: boolean;

    bottomNav = 1;

    get currentUser(): User {
        // debugger
        return this.$store.state.user;
    }

    get userConfig() {
        return this.currentUser.profile?.configuration;
    }

    get enableBank() {
        return (
            this.userConfig?.bankTransaction?.read &&
            (!this.currentUser.companyUser || !this.currentUser.companyUser?.accessRights.length)
        );
    }

    get accountingPeriodId() {
        return this.$store.state.accountingPeriod?.selectedAccountingPeriod?.id;
    }

    get lastSelectedAccountingPeriodId() {
        return this.$store.state.accountingPeriod?.lastSelectedAccountingPeriod?.id;
    }

    get showOutStandingCount() {
        let count = 0;
        if (this.currentUser.showOutStandingClient) count++;
        if (this.currentUser.showOutStandingSupplier) count++;
        if (this.currentUser.showOutStandingExpenseReport) count++;
        if (this.currentUser.showOutStandingSalary) count++;

        return count;
    }

    @Apollo({
        query: ACCOUNTING_COMPANY_OF_COMPANY,
        variables() {
            return {
                companyId: this.currentUser.company.id,
            };
        },
        skip() {
            return !this.currentUser.company?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companies && data.companies.length) {
                    this.accountingFirm = data.companies[0];
                }
            }
        },
    })
    accountingFirm = null;

    @Apollo({
        query: ACCOUNTING_FIRM_CLIENT,
        variables() {
            return {
                clientId: this.selectedCompany.id,
                accountingFirmId: this.accountingFirm.id,
            };
        },
        skip() {
            return !this.selectedCompany?.id || !this.accountingFirm?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data.accountingFirmClientFirst) {
                    this.accountingFirmClient = data.accountingFirmClientFirst;
                } else {
                    this.accountingFirmClient = null;
                }
            }
        },
    })
    accountingFirmClient = null;

    @Apollo({
        query() {
            return GET_ALL_TUTORIALS;
        },
        variables() {
            return {};
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.learningObjects) {
                    this.tutorials = data.learningObjects;

                    if (this.tutorials && this.tutorials.length) {
                        this.buildComponentDictionary(this.tutorials);
                    }
                } else {
                    this.tutorials = [];
                }
            }
        },
    })
    tutorials: any = [];

    buildComponentDictionary(learningObjects) {
        const dictionary = {};

        learningObjects.forEach((learningObject) => {
            if (learningObject.starterComponents) {
                const components = learningObject.starterComponents
                    .split(";")
                    .filter((component) => component.trim() !== "");
                components.forEach((component) => {
                    if (!dictionary[component]) {
                        dictionary[component] = [];
                    }
                    if (!dictionary[component].includes(learningObject.key)) {
                        dictionary[component].push(learningObject.key);
                    }
                });
            } else {
                if (!dictionary["Sans starterComponents"]) {
                    dictionary["Sans starterComponents"] = [];
                }
                dictionary["Sans starterComponents"].push(learningObject.key);
            }
        });

        // Ajout des LearningObject sans starterComponents qui ont été filtrés précédemment
        learningObjects.forEach((learningObject) => {
            if (
                !learningObject.starterComponents ||
                learningObject.starterComponents
                    .split(";")
                    .filter((component) => component.trim() !== "").length === 0
            ) {
                if (!dictionary["Sans starterComponents"]) {
                    dictionary["Sans starterComponents"] = [];
                }
                if (!dictionary["Sans starterComponents"].includes(learningObject.key)) {
                    dictionary["Sans starterComponents"].push(learningObject.key);
                }
            }
        });

        const formattedDictionary = {};
        Object.keys(dictionary).forEach((component) => {
            formattedDictionary[component] = dictionary[component].join(", ");
        });

        // Store the dictionary in Vuex store
        this.$store.commit("updateComponentDictionary", formattedDictionary);
    }

    get logo() {
        if (this.accountingFirm && this.accountingFirm.logo && this.accountingFirm.logo.signedUrl) {
            return this.accountingFirm.logo.signedUrl;
        }
        if (this.currentUser?.company?.logo?.signedUrl) {
            return this.currentUser.company.logo.signedUrl;
        }

        return logoBobbeeMini;
    }

    get companyList(): Array<any> {
        if (this.companySearch === "") {
            return sortBy(this.currentUser.allAvailableCompanies, (x) =>
                (x.shortname || x.name).toLowerCase(),
            );
        }
        return sortBy(
            this.currentUser.allAvailableCompanies.filter((x) =>
                x.name.toLowerCase().includes(this.companySearch.toLowerCase()),
            ),
            "name",
        );
    }

    get selectedCompany() {
        // debugger
        return this.$store.state.selected_company || { id: "" };
    }

    set selectedCompany(selectedCompany) {
        if (this.$route?.params?.companyId) {
            return;
            // const company = this.currentUser.allAvailableCompanies.find(x => x.id === this.$route.params.companyId)
            // if (company) {
            //     return
            // }
        }
        setCurrentCompany(this.$apollo, this.$store, selectedCompany, undefined, true);
    }

    get documentStartDate() {
        const date = this.$store.getters.getDocumentStartDate();
        if (!date || !moment(date).isValid()) {
            return undefined;
        }
        return getDBFormattedDate(date);
    }

    get documentEndDate() {
        const date = this.$store.getters.getDocumentEndDate();
        if (!date || !moment(date).isValid()) {
            return undefined;
        }
        return getDBFormattedDate(date);
    }

    @Apollo({
        query() {
            return USED_TAG_QUERY;
        },
        variables() {
            return {
                companyId: this.selectedCompany.id,
                mode: "document",
                startDate: this.documentStartDate,
                endDate: this.documentEndDate,
            };
        },
        skip() {
            return !this.selectedCompany || !this.selectedCompany.id;
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.usedTags = [];
                if (data.usedTags && data.usedTags.tags) {
                    // debugger
                    // getCompanyTags(this, this.selectedCompany.id,data.usedTags.tags, this.documentUsedTags);
                    this.documentUsedTags = formatTagsToTreeView(data.usedTags.tags);
                }
            }
        },
    })
    documentUsedTags = [];

    @Apollo({
        query() {
            return USED_TAG_QUERY;
        },
        variables() {
            return {
                companyId: this.selectedCompany.id,
                mode: "bankTransaction",
                startDate: this.documentStartDate,
                endDate: this.documentEndDate,
            };
        },
        skip() {
            return !this.selectedCompany || !this.selectedCompany.id;
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.usedTags = [];
                if (data.usedTags && data.usedTags.tags) {
                    // debugger;
                    const _bankTransactionUsedTags = [];
                    getCompanyTags(
                        this,
                        this.selectedCompany.id,
                        data.usedTags.tags,
                        _bankTransactionUsedTags,
                    );
                    this.bankTransactionUsedTags = _bankTransactionUsedTags;
                }
            }
        },
    })
    bankTransactionUsedTags = [];

    get usedFilters() {
        const filters = [
            {
                name: "Dernière modification",
                type: "orderBy",
                value: "updatedAt-desc",
            },
            {
                name: "Dernière création",
                type: "orderBy",
                value: "createdAt-desc",
            },
            {
                name: "Document à vérifier",
                type: "status",
                value: "analysed",
            },
        ];

        return filters;
    }

    routerPushWithFilters(filter) {
        if (filter.value) {
            this.routerPush({ name: "documents", query: { [filter.type]: filter.value } });
        }
    }

    getCompanyDisplayName(company) {
        return company.shortname || company.name;
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get companyAccountingFirmId() {
        return this.$store.state.companyAccountingFirm?.id;
    }

    get topButtonStyle() {
        let style = "pointer-events:auto; margin-right: 3px;";
        if (!this.$vuetify.display.mobile) {
            style += " color: #000;";
        }
        return style;
    }

    get topButtonColor() {
        if (this.$vuetify.display.mobile) return "";
        return "primary";
    }

    get topButtonText() {
        if (this.$vuetify.display.mobile) return true;
        return false;
    }

    get topButtonFab() {
        if (this.$vuetify.display.mobile) return false;
        return true;
    }

    get showNavigationDrawer() {
        if (this.$route.name === "maintenance") return false;
        if (this.$vuetify.display.mobile) return false;
        if (!this.currentUser || !this.currentUser.profile) return false;
        if (this.toBeDoneStatus) return false;

        const history = (this.$router as any).history;

        return true;
    }

    get styleMiniBtn() {
        if (this.mini) {
            return "position: fixed; bottom: 10px; left: 40px; transition: all 280ms ease; z-index: 4";
        }
        return "position: fixed; bottom: 10px; z-index: 100; left: 237px; transition: all 280ms ease;";
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get isRootUser() {
        return this.currentUser.isRoot;
    }

    get isBusinessClient() {
        return this.currentUser.isBusinessClient;
    }
    get isUserInAccountingFirm() {
        return this.currentUser.isInAccountingFirm || this.isRootUser;
    }

    get isAutonomousUser() {
        return this.currentUser?.isAutonomousUser;
    }

    get isUserConnected() {
        return this.currentUser?.isConnected;
    }

    get isHomeAvailable() {
        // debugger;
        if (this.isRootUser) {
            return true;
        }
        if (this.isUserInAccountingFirm) {
            return true;
        }
        if (this.isBusinessClient) {
            if (this.companyAccountingFirmId === this.selectedCompany.id) {
                return true;
            }
        }
        return false;
    }

    get margin() {
        if (this.offsetTop < 30) {
            return "padding-bottom: 0px";
        }
        return "pointer-events:none; padding-bottom:" + (this.offsetTop - 30) * 2 + "px";
    }

    beforeMount() {
        this.$store.commit("setInternalManagement", false);
        // debugger
        // document.addEventListener('fetch', function(event: any) {
        //     console.log("fetch event:", event.request.url);
        // });
        if (this.$store.state.user.firstLogin) {
            this.activateHelp = false;
            this.firstLoginDialog = true;
        }
        this.currentRouteStore = this.currentRoute as string;
    }

    beforeDestroy() {
        if (this.$apollo.queries && this.$apollo.queries.applicationSettings) {
            this.$apollo.queries.applicationSettings.stop();
        }
        this.removeListener();
        // if (this.applicationSettingsSubscription) {
        //     this.applicationSettingsSubscription.unsubscribe()
        // }
    }

    @Apollo({
        query: gql`
            query applicationSettings {
                applicationSettings(where: { name: "web" }) {
                    id
                    maintenance
                }
            }
        `,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.applicationSettings) {
                    this.applicationSettings = data.applicationSettings;
                    updateMaintenance(
                        this.$route,
                        this.$store,
                        this.$router,
                        data.applicationSettings,
                    );
                }
            }
        },
    })
    applicationSettings = null;

    async logout() {
        // this.$store.commit("logoutUser");
        logOutUser(this.$store, this.$router);
    }

    // profileId_ = ""
    // config= {
    //     ogaEnrolment: false,
    //     ogaEnrolmentConfig: {
    //         numberId: "", designation: "", address: "", postalCode: "", city: ""
    //     }
    // }

    get companyProfileId() {
        return this.currentUser.company.profile.id || "";
    }

    // async updateProfile() {
    //     const result = await this.$apollo.mutate({
    //         mutation: UPSERT_PROFILE_COMPANY,
    //         variables: {
    //             ...this.config,
    //             companyId: this.companyId,
    //             id: this.companyProfileId,
    //             // vatBankAccountUpdate: this.config.vatBankAccount.id ? { connect: {
    //             //     id: this.config.vatBankAccount.id
    //             // }} : undefined,
    //             // vatBankAccountCreate: this.config.vatBankAccount.id ? { connect: {
    //             //     id: this.config.vatBankAccount.id
    //             // }} : undefined,
    //             ogaEnrolmentConfig: this.config.ogaEnrolment ? this.config.ogaEnrolmentConfig : {
    //                 numberId: "", designation: "", address: "", postalCode: "", city: ""
    //             },
    //         }
    //     })
    //     this.profileId_ = result.data.upsertProfileCompany.id
    //     // await this.$apollo.queries.config.refetch();
    // }

    onScroll(e) {
        this.offsetTop = window.pageYOffset || document?.documentElement.scrollTop;
    }

    async playStop() {
        // await this.$apollo.mutate({
        //     mutation: gql(`mutation{updateApplicationSettings(
        //     where:{name:"web"}
        //     data:{
        //     maintenance: true
        //     }){id}}`)
        // });
        if (this.toBeDoneStatus) {
            this.toBeDoneStatus = false;
            this.$router.back();
        } else {
            this.toBeDoneStatus = true;
            this.routerPush({
                name: "toBeDone",
                params: { companyId: this.selectedCompany.id },
            });
        }
    }

    close() {
        this.activateHelp = false;
    }

    back() {
        if (this.toBeDoneStatus) {
            this.toBeDoneStatus = false;
            this.$router.back();
        } else {
            this.$router.go(-1);
        }
    }

    resetChangePassword() {
        this.password = "";
        this.pwdConfirmation = "";
        this.passwordChange = false;
        if (this.firstLoginDialog) {
            this.activateHelp = true;
            this.firstLoginDialog = false;
        }
    }

    isAuth() {
        // if (this.env.ENABLE_COGNITO) {
        //     return this.env.ENABLE_COGNITO
        // }
        const name = this.$route.name;
        if (
            name === "login" ||
            name === "signup" ||
            name === "password-recovery" ||
            name === "password-reset" ||
            name === "email-verification" ||
            name === "maintenance"
        ) {
            return true;
        }
        return false;
    }

    async sendEmailConfirmation() {
        if (!this.emailConfirmationResent) {
            await this.$apollo.mutate({
                mutation: gql(`mutation{sendEmailConfirmation{status}}`),
            });
            this.emailConfirmationResent = true;
        }
    }

    get apolloErrors() {
        console.log(this.$store.state.apolloErrors);
        return this.$store.state.apolloErrors;
    }

    @Watch("apolloErrors")
    test() {
        console.log("errors", this.apolloErrors);
        this.apolloErrorSnackBar = true;
        this.loading = false;
    }

    //
    // CHAT LIST
    //
    // open_chat:boolean = false

    get openChatList() {
        if (!this.currentUser) return false;
        if (!this.currentUser.profile) return false;
        if (!this.userConfig?.chat?.read) return false;

        return showChatList(this.$route.name);
    }

    onChatSelected(data) {
        if (data && data.chat && data.chat) {
            // this.onItemClick(data.chat);
        }
    }

    tutorialBack() {
        this.tutorialWizard.goBack();
    }

    //
    // chat subcription
    //

    // @Apollo({
    // query: COMPANY_CHAT_USER,
    // variables() {
    // return {
    // companyId: this.selectedCompany.id,
    // userId: this.currentUser.id,
    // };
    // },
    // specificResult({ data, loading, networkStatus }: any) {
    // result: ({ data, loading, networkStatus }: any) => {
    // if (!loading) {
    // if (data?.chatUsers?.length) {
    // console.log(data);
    // this.chatUser = data.chatUsers[0];
    // this.addListener("chatUser");
    // } else {
    // this.chatUser = null;
    // this.removeListener();
    // }
    // }
    // },
    // skip() {
    // return !this.isAccountingUser || !this.selectedCompany?.id || !this.currentUser?.id;
    // },
    // })
    chatUser: any = null;

    onMessage(data) {
        if (data) {
            if (data.action === "create") {
                debugger;
            } else if (data.action === "update" && this.chatUser) {
                if (data.id === this.chatUser.id) {
                    this.chatUser.unreadMessageCount = data.payload.unreadMessageCount;
                }
            }
        }
    }

    setNotificationDateForToday() {
        const date: Date = new Date();

        localStorage.setItem("lastTimeFreemiumNotificationWasDisplayed", date.toString());
        this.isFirstConnection = false;
    }
}

export default toNative(Index);
</script>
<style scoped lang="scss">
.v-content__wrap {
    height: 100% !important;
}

span.company-name {
    margin-left: 5px;
}

.background_image {
    background-color: #f4f4f4;
}

.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 16px;
}

.navigation a {
    text-decoration: none !important;
}

.custom-expand-button {
    width: 37px;
}

.expanded-group-content {
    max-height: 25vh;
    overflow-y: auto;
}

.v-list-group .v-list-group__items .v-list-item {
    padding-left: 32px !important;
}

.v-list-group .v-list-group__items .v-list-subheader {
    padding-left: 32px !important;
}

.v-list-item-title-active {
    font-size: 0.9rem;
    line-height: 1.4;
    white-space: normal;
    word-break: break-word;
}

.v-list-item-title-active-no-word {
    font-size: 0.9rem;
    line-height: 1.8;
    white-space: normal;
}
</style>
